import React from 'react'
import { Route } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import { getUserInfoFromLocalStorage } from '@/utils/auth'
import UserActions from '@/actions/User'
import AuthActions from '@/actions/Auth'
import NavbarConsoleContainer from '@/containers/Console/Navbar'
import { getStringByTextKey } from '@/utils/getStringByTextKey'
import { getLanguage } from '@/utils/localization'

@inject('store')
@observer
export default class ProtectedRoute extends React.Component {
  commonStore = this.props.store.commonStore

  state = {
    initDone: false
  }

  async componentWillMount() {
    const userInfo = JSON.parse(getUserInfoFromLocalStorage())
    const lang = getLanguage()
    try {
      const sessionCheck = await UserActions.sessionCheck()
      if (userInfo !== null && sessionCheck === 'OK') {
        if (userInfo.userInfo.loginType === 'FASOO_AD') {
          await AuthActions.logout()
          window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
        } else {
          this.commonStore.setUserInfo(userInfo)
        }
      } else if (userInfo) {
        window.alert(getStringByTextKey('common.alert.sessionExpired'))
        await AuthActions.logout()
        window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
      } else {
        await AuthActions.logout()
        window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
      }
    } catch (error) {
      if (userInfo !== null) {
        window.alert(getStringByTextKey('common.alert.sessionExpired'))
        await AuthActions.logout()
        window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
      } else {
        await AuthActions.logout()
        window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
      }
    }

    await this.commonStore.setNavStepRefresh()
    await this.commonStore.setHasSiteRefresh()
    await this.commonStore.setHasBillRefresh()

    this.setState({ initDone: true })
  }

  async componentWillReceiveProps(newProps) {
    const userInfo = JSON.parse(getUserInfoFromLocalStorage())
    const sessionCheck = await UserActions.sessionCheck()
    const lang = getLanguage()
    try {
      if (userInfo !== null && sessionCheck === 'OK') {
        this.commonStore.setUserInfo(userInfo)
      } else if (userInfo) {
        window.alert(getStringByTextKey('common.alert.sessionExpired'))
        await AuthActions.logout()
        window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
      } else {
        await AuthActions.logout()
        window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
      }
    } catch (error) {
      if (userInfo !== null) {
        window.alert(getStringByTextKey('common.alert.sessionExpired'))
        await AuthActions.logout()
        window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
      } else {
        await AuthActions.logout()
        window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
      }
    }

    this.setState({ initDone: true })
  }

  render() {
    const { component: C, props } = this.props
    const { initDone } = this.state
    const renderArr = []
    return initDone ? (
      <Route
        render={cProps => {
          renderArr.push(
            <NavbarConsoleContainer key="navbar" {...props} {...cProps} />
          )

          renderArr.push(<C key="body" {...props} {...cProps} />)

          return renderArr
        }}
      />
    ) : (
      ''
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute.js